import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BasicInput, DatePickerField, BasicFieldCheckbox, BaasicFormControls, BaasicButton } from "core/components";
import { Content } from "core/layouts";

const TrackingCaseDocumentFieldValueEditModalTemplate = function({ trackingCaseDocumentFieldValueEditModalStore, componentProps, t }) {
    const {
        contentLoading,
        form,
        fieldValue
    } = trackingCaseDocumentFieldValueEditModalStore;

    function renderInputType() {
        if(fieldValue) {
            switch(fieldValue.documentFormFieldType.abrv) {
            case 'date':
                return <DatePickerField field={form.$('value')} />;
            case 'check':
                return <BasicFieldCheckbox field={form.$('value')} />;
            default:
                return <BasicInput field={form.$('value')} />;
            }
        }
    }

    return (
        <form onSubmit={form.onSubmit}>
            <div className="modal__header">
                <h1 className="modal__header__title">
                    Edit Field Value - {fieldValue && fieldValue.name}
                </h1>
            </div>
            <div className="modal__body">
                <Content loading={contentLoading}>
                    <div className="form__group">
                        {renderInputType()}
                    </div>
                </Content>
            </div>
            <div className="modal__footer">
                <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting}  className='btn btn--med btn--primary'/>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => componentProps.modalParams.close()}
                />
            </div>
        </form>
    );
};

TrackingCaseDocumentFieldValueEditModalTemplate.propTypes = {
    trackingCaseDocumentFieldValueEditModalStore: PropTypes.object.isRequired,
    componentProps: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(TrackingCaseDocumentFieldValueEditModalTemplate);